<template>
  <WsMain class="allow-overflow">
    <WsTitle>批次上傳{{ label }}</WsTitle>
    <v-stepper v-model="step" class="elevation-0 transparent">
      <v-stepper-header class="elevation-0">
        <v-stepper-step step="1" editable>選擇分段依據</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" editable>匯入來源</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" editable>編輯內容</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="mt-5">
        <v-stepper-content step="1" class="pa-0">
          <WsCard>
            <div class="ws-content" :style="{ 'min-height': '700px' }">
              <ValidationObserver ref="form">
                <v-row>
                  <v-col
                    v-for="(parseField, parseFieldKey) in parseFields"
                    :key="parseFieldKey"
                    sm="12"
                    cols="12"
                  >
                    <WsState
                      v-model="parseFieldValues[parseField.valueKey]"
                      :type="parseField.type"
                      :label="parseField.label"
                      :items="parseField.items"
                      :defaultValue="parseField.defaultValue"
                      :clearable="parseField.clearable"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="localeMode">
                  <v-col cols="12" sm="3">
                    <WsState
                      v-model="locale"
                      required
                      type="select"
                      label="輸入語言"
                      rules="required"
                      :items="_localeItems"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="someFields">
                  <v-col
                    v-for="(field, fieldKey) in someFields"
                    :key="fieldKey"
                    cols="12"
                    :sm="field.sm"
                  >
                    <WsState
                      :value="someFieldsValue[fieldKey]"
                      :type="field.type"
                      :label="field.label"
                      :rules="field.rules"
                      :maxlength="field.maxlength"
                      :required="field.rules ? field.rules.includes('required') : false"
                      @input="$_onSomeFieldsValue($event, fieldKey)"
                    />
                  </v-col>
                </v-row>
              </ValidationObserver>
            </div>
          </WsCard>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-0">
          <v-row>
            <v-col>
              <WsCard>
                <div class="ws-content" :style="{ 'min-height': '300px' }">
                  <WsContentTitle>{{ compareTitleFirst }}</WsContentTitle>
                  <WsState
                    v-model="contentFirst"
                    type="textarea"
                    :label="`${compareTitleFirst}原文`"
                  />
                </div>
              </WsCard>
            </v-col>
            <v-col>
              <WsCard>
                <WsContent minHeight="300px">
                  <WsContentTitle>{{ compareTitleSecond }}</WsContentTitle>
                  <WsState
                    v-model="contentSecond"
                    type="textarea"
                    :label="`${compareTitleSecond}原文`"
                  />
                </WsContent>
              </WsCard>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="3">
          <div v-if="submitLoading">
            <v-skeleton-loader
              v-for="n in 3"
              :key="`skeleton-${n}`"
              tile
              type="list-item-three-line"
              class="mt-5"
            ></v-skeleton-loader>
          </div>
          <WsCompareMerge
            v-else
            compareField="content"
            :firstData="firstParseResult"
            :inputFields="compareFields"
            :titleFirst="compareTitleFirst"
            :secondData="secondParseResult"
            :titleSecond="compareTitleSecond"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <WsMainBottomNav>
      <WsBtn v-if="step > 1" outlined color="textSecondary" @click="$_onPrevClick">上一步</WsBtn>
      <WsBtn v-if="step < 3" :loading="submitLoading" @click="$_onNextClick">下一步</WsBtn>
      <WsBtn v-if="step === 3" :loading="submitLoading" @click="$_onSubmit">送出</WsBtn>
    </WsMainBottomNav>
    <WsAlertDialog
      ref="WsAlertDialog"
      :title="alertPopup.title"
      :color="alertPopup.color"
      :btnText="alertPopup.btnText"
      :description="alertPopup.description"
      @submit="$_onClickAlertDialog($event)"
    />
  </WsMain>
</template>

<script>
export default {
  props: {
    localeMode: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    backRoute: {
      type: String,
      default: null,
    },
    backRouteText: {
      type: String,
      default: '返回',
    },
    modelName: {
      type: String,
      default: null,
    },
    compareMode: {
      type: Boolean,
      default: false,
    },
    compareTitleFirst: {
      type: String,
      default: null,
    },
    compareTitleSecond: {
      type: String,
      default: null,
    },
    someFields: {
      type: Object,
      default() {
        return {};
      },
    },
    someFieldsValue: {
      type: Object,
      default() {
        return {};
      },
    },
    parseFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      step: 1,
      submitLoading: false,
      contentFirst: '',
      contentSecond: '',
      locale: null,
      firstParseResult: [],
      secondParseResult: [],
      alertPopup: {
        title: '',
        description: '',
        btnText: '',
        color: '',
      },
      parseFieldValues: {},
      compareFields: {},
    };
  },
  computed: {
    _localeItems() {
      const _localeItems = [];
      const locales = this.$store.state.locale.locales;
      if (!locales) {
        return null;
      }
      locales.forEach((locale) => {
        _localeItems.push({
          value: locale.code,
          text: locale.name,
        });
      });
      return _localeItems;
    },
  },
  watch: {
    step: {
      handler() {
        if (this.step === 3) {
          this.submitLoading = true;
          setTimeout(() => {
            this.firstParseResult = this.$_getParseArr(this.contentFirst);
            this.secondParseResult = this.$_getParseArr(this.contentSecond);
            this.submitLoading = false;
          }, 500);
        }
      },
    },
  },
  mounted() {
    this.$_initTitleVale();
  },
  methods: {
    loadingStart() {
      this.submitLoading = true;
    },
    loadingStop() {
      this.submitLoading = false;
    },
    $_getParseArr(text) {
      if (!text) return [];
      const parseArr = [];
      const lineArr = text.match(/[^\r\n]+/g);
      if (!lineArr) return [];

      const baseParseItem = { content: '', isSelected: false };
      const parseSettings = [];
      Object.entries(this.parseFieldValues).forEach(([key, value]) => {
        if (key === 'articleInlineTextRule' || value == null) return;
        parseSettings.push({ key, regex: new RegExp(value) });
        baseParseItem[key] = '';
      });
      if (parseSettings.length === 0) return [];
      const inlineTextAsContent = this.parseFieldValues.articleInlineTextRule === 'asContent';

      lineArr.forEach((lineItem) => {
        const line = lineItem.trim();
        if (!line) return;

        const lastParse = parseArr[parseArr.length - 1];
        let matched = false;

        // 尋找匹配的解析設定
        for (let i = 0; i < parseSettings.length; i++) {
          const { key, regex } = parseSettings[i];
          const matchArr = line.match(regex);
          if (matchArr && matchArr[0].length === line.length) {
            const isArticleInlineAsContent = key === 'no_text' && inlineTextAsContent;
            const keyContent = isArticleInlineAsContent
              ? matchArr[1].trim()
              : `${matchArr[1].trim()} ${matchArr[2].trim()}`;
            const content = isArticleInlineAsContent ? matchArr[2].trim() : '';
            const parseItem = {
              ...baseParseItem,
              [key]: keyContent,
              ...(content ? { content } : {}),
            };

            if (i === 0) {
              // 第一個設定匹配，建立新項目
              parseArr.push(parseItem);
            } else {
              // 後續設定匹配
              if (!lastParse) {
                // 沒有最後一個項目，建立新項目
                parseArr.push(parseItem);
              } else if (
                lastParse &&
                (lastParse[key] || lastParse[parseSettings[parseSettings.length - 1].key])
              ) {
                // 如果最後一個項目已有此欄位或是最後一個項目有最後一個parseSettings的設定(目前是內容欄位)，則建立新項目
                parseArr.push(parseItem);
              } else if (lastParse) {
                // 否則更新最後一個項目
                lastParse[key] = keyContent;
                if (isArticleInlineAsContent) {
                  lastParse.content = lastParse.content
                    ? `${lastParse.content}\n${content}`
                    : content;
                }
              }
            }

            matched = true;
            break;
          }
        }

        // 如果沒有匹配任何設定且有最後一個項目，將內容加入
        if (!matched && lastParse) {
          lastParse.content = lastParse.content ? `${lastParse.content}\n${line}` : line;
        }
      });

      return parseArr;
    },
    $_getSBC(str) {
      let result = '';
      for (let i = 0; i < str.length; i++) {
        let cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248（十進位制）
        cCode = cCode >= 0xff01 && cCode <= 0xff5e ? cCode - 65248 : cCode;
        //處理空格
        cCode = cCode == 0x03000 ? 0x0020 : cCode;
        result += String.fromCharCode(cCode);
      }
      return result;
    },
    $_getDBC(str) {
      let result = '';
      for (let i = 0; i < str.length; i++) {
        let cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248(十進位制)
        cCode = cCode >= 0x0021 && cCode <= 0x007e ? cCode + 65248 : cCode;
        //處理空格
        cCode = cCode == 0x0020 ? 0x03000 : cCode;
        result = String.fromCharCode(cCode);
      }
      return result;
    },
    $_onPrevClick() {
      if (this.step === 3) {
        this.alertPopup = this.$_onSetAlertPopup('resetData');
        this.$refs.WsAlertDialog.open();
      } else this.step--;
    },
    async $_onNextClick() {
      if (this.step === 1) {
        const isValidate = await this.$refs.form.validate();
        if (!isValidate) return;
      }
      if (this.step === 2) {
        this.$_setCompareFields();
      }
      this.step++;
    },
    $_submitCheck() {
      let check = true;
      for (let i = 0; i < this.firstParseResult.length; i++) {
        if (!check) return check;
        check = this.firstParseResult[i].isSelected || this.secondParseResult[i].isSelected;
      }
      return check;
    },
    $_onSubmit() {
      if (!this.$_submitCheck()) {
        alert('比較未完成');
        return;
      }
      const submitData = {
        submitArr: this.firstParseResult.map((first, index) =>
          first.isSelected ? first : this.secondParseResult[index],
        ),
      };
      if (this.localeMode) {
        submitData.locale = this.locale;
      }
      this.$emit('submit', submitData);
    },
    $_onSomeFieldsValue($event, fieldKey) {
      this.someFieldsValue[fieldKey] = $event;
      this.$emit('someFieldsValue', this.someFieldsValue);
    },
    $_onSetAlertPopup(type) {
      const alertList = {
        default: {
          title: '要進行動作嗎？',
          btnText: '確認',
          color: 'primary',
        },
        resetData: {
          title: '編輯的內容會清除，確認要返回上一步嗎？',
          btnText: '確認',
        },
      };
      return alertList[type] ? alertList[type] : alertList.default;
    },
    $_onClickAlertDialog() {
      this.$refs.WsAlertDialog.close();
      this.step--;
    },
    $_initTitleVale() {
      this.parseFieldValues = this.parseFields.reduce((acc, parseField) => {
        acc[parseField.valueKey] = parseField.defaultValue || null;
        return acc;
      }, {});
    },
    $_setCompareFields() {
      const fields = Object.entries(this.parseFieldValues)
        .filter(([key, value]) => key !== 'articleInlineTextRule' && value !== null)
        .reduce((acc, [key]) => {
          acc[key] = {
            type: 'text',
            label: this.$_setCompareLabel(key),
          };
          return acc;
        }, {});

      fields.content = {
        type: 'textarea',
        label: '內容',
        withCompareTitle: true,
      };

      this.compareFields = fields;
    },
    $_setCompareLabel(key) {
      const field = this.parseFields.find((field) => field.valueKey === key);
      return field ? field.compareLabel || '' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.allow-overflow ::v-deep {
  margin-bottom: 100px;
  .v-stepper,
  .v-stepper__items,
  .v-stepper__content,
  .v-stepper__wrapper {
    overflow: visible !important;
  }
}
</style>
